import React from "react"
import { format, isValid } from "date-fns"

export default function DateTime({
  date,
  displayFormat = `MMM d '@' h:mm a`,
  ...rest
}) {
  return isValid(date) ? (
    <time dateTime={date.toString()} {...rest}>
      {`${format(date, displayFormat)}`}
    </time>
  ) : null
}
